import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_SALON_LIST_URL = `${process.env.PUBLIC_URL}/api/v1/r/salonList`;
export const GET_SALON_LIST = "GET_SALON_LIST";
export const GET_SALON_LIST_COMPLETED = "GET_SALON_LIST_COMPLETED";
export const GET_SALON_LIST_FAILED = "GET_SALON_LIST_FAILED";
export function getSalonList() {
  const queryFilter = {
    order: "name ASC"
  };
  return queryAll(GET_SALON_LIST_URL, queryFilter, GET_SALON_LIST, GET_SALON_LIST_COMPLETED,
    GET_SALON_LIST_FAILED);
}

export const SEARCH_SALONS = 'SEARCH_SALONS';
export const SEARCH_SALONS_COMPLETED = 'SEARCH_SALONS_COMPLETED';
export const SEARCH_SALONS_FAILED = 'SEARCH_SALONS_FAILED';
export const searchSalons = querySearch(GET_SALON_LIST_URL, SEARCH_SALONS, SEARCH_SALONS_COMPLETED,
  SEARCH_SALONS_FAILED, ['name', 'address', 'phoneNumber']);

export const GET_SALON = "GET_SALON";
export const GET_SALON_COMPLETED = "GET_SALON_COMPLETED";
export const GET_SALON_FAILED = "GET_SALON_FAILED";
export function getSalon({salonId}) {
  const filter = {
    where: {
      salonId
    }
  };
  return queryOne(GET_SALON_LIST_URL, filter, GET_SALON, GET_SALON_COMPLETED, GET_SALON_FAILED);
}

export const SELECT_SALON = "SELECT_SALON";
export function selectSalon(salonId) {
  return {type: SELECT_SALON, payload: {salonId}};
}

const SALON_URL = `${process.env.PUBLIC_URL}/api/v1/salon`;
export const ADD_SALON = 'ADD_SALON';
export const ADD_SALON_COMPLETED = 'ADD_SALON_COMPLETED';
export const ADD_SALON_FAILED = 'ADD_SALON_FAILED';
export const addSalon = command(SALON_URL + '/addSalon', ADD_SALON, ADD_SALON_COMPLETED,
  ADD_SALON_FAILED);

export const UPDATE_SALON = 'UPDATE_SALON';
export const UPDATE_SALON_COMPLETED = 'UPDATE_SALON_COMPLETED';
export const UPDATE_SALON_FAILED = 'UPDATE_SALON_FAILED';
export const updateSalon = command(SALON_URL + '/updateSalon', UPDATE_SALON,
  UPDATE_SALON_COMPLETED, UPDATE_SALON_FAILED);



// WEBPACK FOOTER //
// ./src/Salon/actions.js